import theme from '!!../../util/less-to-js-loader!./variables.less';

export default theme;
